import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IGet } from '../authorization';
import { IBaseResponse, IRecipient } from '@nkr/models/index';
import { IPut } from '../authorization/actions';

export interface IRecipientLabsReviewedResponse {
    data: {
        success: boolean,
        results: string[]
    }
}

export interface IRecipientSaveToolboxAvoidsResponse {
    data: {
        success: boolean,
        message,
        results: {
            labReviewHistory: string[],
            recipient: IRecipient,
            labLastReviewedDate: string
        }
    }
}

export interface IToolboxAvoidsRequest {
    aAvoids: number[],
    bAvoids: number[],
    drAvoids: number[],
    bwAvoids: number[],
    cwAvoids: number[],
    dqbAvoids: number[],
    dqaAvoids: number[],
    dpbAvoids: number[],
    avoidDr51: boolean,
    avoidDr52: boolean,
    avoidDr53: boolean,
    labLastReviewedDate: string
}

export interface IEpletGraphDataResult {
    recipientId: number,
    hasMismatchCount: boolean,
    estimatedWaitMmIntermediate: number,
    estimatedWaitMmLow: number,
    estimatedWaitMmNone: number,
    xAxis_Eplet: number[],
    yAxis_Eplet: number[]
}

export interface IEpletGraphDataResponse {
    data: {
        success: boolean,
        results: IEpletGraphDataResult
    }
}

export const ActionCreators = {
    getToolbox: (recipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let options: IGet = {
            url: `${__API__}/recipient/${recipientId}/toolbox`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    saveToolboxPreferences: (recipientId: number, requireEplet: number, ebvPreference: number, cmvPreference: number, screeningComments: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPut = {
            url: `${__API__}/recipient/${recipientId}/toolbox-preferences`,
            data: {
                requireEplet,
                screeningComments,
                ebvPreference,
                cmvPreference
            }
        };

        return await dispatch(AuthActionCreators.apiPut(options));
    },

    saveToolboxAvoids: (recipientId: number, data: IToolboxAvoidsRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IRecipientSaveToolboxAvoidsResponse> => {
        let options: IPut = {
            url: `${__API__}/recipient/${recipientId}/toolbox-avoids`,
            data
        };

        return await dispatch(AuthActionCreators.apiPut(options));
    },

    labsReviewed: (recipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IRecipientLabsReviewedResponse> => {
        let options: IPut = {
            url: `${__API__}/recipient/${recipientId}/labs-reviewed`
        };

        return await dispatch(AuthActionCreators.apiPut(options));
    },

    getEpletGraphData: (recipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IEpletGraphDataResponse> => {
        let options: IGet = {
            url: `${__API__}/recipient/${recipientId}/eplet-graph-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
}
